export default () => ({
    variantId: '',
    urls: {},
    amazonUrl: '',
    variantChangeHandler: null,
  
    init() {
      this.variantId = String(this.$el.dataset.initialVariantId || '');
  
      const urlMapId = this.$el.dataset.urlMapId;
      const urlMapElement = document.getElementById(urlMapId);
  
      if (!urlMapElement) {
        return;
      }
  
      try {
        this.urls = JSON.parse(urlMapElement.textContent);
      } catch (error) {
        console.error('Could not parse Amazon variant URLs:', error);
        return;
      }
  
      this.updateAmazonUrl();
  
      this.variantChangeHandler = (event) => {
        this.handleVariantChange(event);
      };
  
      document.addEventListener(
        'variant:change',
        this.variantChangeHandler
      );
    },
  
    handleVariantChange(event) {
      const variant = event.detail?.variant;
  
      if (!variant?.id) {
        return;
      }
  
      const variantId = String(variant.id);
  
      // Ignore variant changes from other products/components.
      if (!Object.prototype.hasOwnProperty.call(this.urls, variantId)) {
        return;
      }
  
      this.variantId = variantId;
      this.updateAmazonUrl();
    },
  
    updateAmazonUrl() {
      this.amazonUrl = this.urls[this.variantId] || '';
    },
  
    destroy() {
      if (!this.variantChangeHandler) {
        return;
      }
  
      document.removeEventListener(
        'variant:change',
        this.variantChangeHandler
      );
    }
  });